import * as actions from 'actions';
import byIdMaker from 'reducersMakers/byIdMaker';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.MAIL_THREADS_FETCH_SUCCESS,
    actions.MAIL_THREAD_MESSAGES_FETCH_SUCCESS
  ],
  updateSuccessTypes: [
   actions.MAIL_THREAD_MESSAGE_UPDATE_SUCCESS
  ],
  updateKey: 'threadMessageId',
  entityType: 'threadMessages'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/mailThreadMessages/byId/reducer.js
 **/